
import { Vue, Component, Ref, Watch } from 'vue-property-decorator';
import lazyInject from '@/di';
import CarService from '@/services/car.service';
import PartialRefoundPopover from './components/PartialRefundPopover.vue';
import CAROrderRemarkModal from './components/CAROrderRemarkModal.vue';
import CarSalesmanChange from './components/CarSalesmanChange.vue';
import CarUploadPaymentOrderNo from './components/CarUploadPaymentOrderNo.vue';
import CarGiveOrderDuration from './components/CarGiveOrderDuration.vue';
import { AuthEnum } from '@/services/permission.service';
import VoucherImgDrawer from '@/views/order/components/VoucherImgDrawer.vue';
import CarPaymentDrawer from './components/CarPaymentDrawer.vue';

@Component({
  components: {
    PartialRefoundPopover,
    CAROrderRemarkModal,
    CarSalesmanChange,
    CarUploadPaymentOrderNo,
    CarGiveOrderDuration,
    VoucherImgDrawer,
    CarPaymentDrawer,
  },
})
export default class OrderBList extends Vue {
  @lazyInject(CarService)
  carService!: CarService;

  @Ref('carOrderRemarkModal')
  carOrderRemarkModal!: CAROrderRemarkModal;


  @Ref('carSalesmanChange')
  carSalesmanChange!: CarSalesmanChange;


  @Ref('carUploadPaymentOrderNo')
  carUploadPaymentOrderNo!: CarUploadPaymentOrderNo;

  @Ref('voucherImgDrawer')
  voucherImgDrawer!: VoucherImgDrawer;

  @Ref('carPaymentDrawer')
  carPaymentDrawer!: CarPaymentDrawer;

  giveOrderVisible = false;

  AuthEnum = AuthEnum;

  cacheNo = '';
  refresh() {
    // console.log('刷新');
  }
  listData = [];


  form: any = {
    regionId: '',
    shopName: '',
    poi: '',
    staff: '',
    payStatus: -1,
    orderNo: '',
    orderId: '',
    packageId: '',
    payChannel: '',
    receiptFlowNo: '',
    payFlowNo: '',
  };

  currentOrder: any = '';

  pagination = {
    total: 0,
    current: 1,
    pageSize: 10,
    onChange: this.pageChange,
  };

  @Watch('$route')
  handleSearch() {
    const { regionId, shopName, poi, staff, payStatus, orderNo, orderId, packageId, payChannel, pageSize, page, payFlowNo, receiptFlowNo } = this.$route.query;
    const query: { [key: string]: any } = {
      page: page || 1,
      pageSize,
    };
    if (regionId) {
      query.region_id = regionId;
      this.form.regionId = regionId;
    }
    if (shopName) {
      query.shop_name = shopName;
      this.form.shopName = shopName;
    }
    if (poi) {
      query.poi = poi;
    }
    if (!payStatus || payStatus === '-1') {
      query.pay_status = '';
      this.form.payStatus = -1;
    } else {
      query.pay_status = payStatus;
      this.form.payStatus = +payStatus;
    }
    if (staff) {
      query.staff = staff;
      this.form.staff = staff;
    }
    if (orderNo) {
      query.order_no = orderNo;
      this.form.orderNo = orderNo;
    }
    if (orderId) {
      query.order_id = orderId;
      this.form.orderId = orderId;
    }
    if (packageId) {
      query.package_id = packageId;
      this.form.packageId = packageId;
    }
    if (payChannel) {
      query.pay_channel = payChannel;
      this.form.payChannel = payChannel;
    }
    if (payFlowNo) {
      query.pay_flow_no = payFlowNo;
      this.form.payFlowNo = payFlowNo;
    }
    if (receiptFlowNo) {
      query.receipt_flow_no = receiptFlowNo;
      this.form.receiptFlowNo = receiptFlowNo;
    }
    this.getList(query);
  }

  copyToClipboard(item: any) {
    this.$copyText(String(item)).then(() => {
      this.$message.success('复制成功');
    }, (err) => {
      this.$message.error(`复制失败:${err}`);
    });
  }

  datyClose() {
    this.giveOrderVisible = false;
    this.handleSearch();
  }


  openRemarkModal(orderNo: string, text = '') {
    this.carOrderRemarkModal.open({
      type: 'BOrder',
      title: '追加备注',
      orderNo: `${orderNo}`,
      text,
    });
  }

  pageChange(page: number, pageSize: number) {
    // console.log(page, pageSize);
    this.pagination.current = page;
    this.pagination.pageSize = pageSize;
    this.changeQuery();
  }

  openUploadPaymentOrderNoModal(order: any) {
    // console.log(order);
    // this.carUploadPaymentOrderNo.open(order);
    this.carPaymentDrawer.init(order);
  }

  search() {
    this.pagination.current = 1;
    this.changeQuery();
  }
  reset() {
    this.pagination.current = 1;
    const { pageSize } = this.pagination;
    const query: { [key: string]: any } = {
      timestamp: `${Math.round(Date.now() / 1000)}`,
      page: 1,
      pageSize,
    };
    this.form = {
      regionId: '',
      shopName: '',
      poi: '',
      staff: '',
      payStatus: -1,
      orderNo: '',
      orderId: '',
      packageId: '',
      payChannel: '',
      receiptFlowNo: '',
      payFlowNo: '',
    };
    this.$router.push({
      query,
    });
  }

  changeQuery() {
    const { regionId, shopName, poi, staff, payStatus, orderNo, orderId, packageId, payChannel, payFlowNo, receiptFlowNo } = this.form;
    const { current, pageSize } = this.pagination;
    const query: { [key: string]: any } = {
      timestamp: `${Math.round(Date.now() / 1000)}`,
      page: current,
      pageSize,
    };
    if (regionId) {
      query.regionId = regionId;
    }
    if (shopName) {
      query.shopName = shopName;
    }
    if (poi) {
      query.poi = poi;
    }
    query.payStatus = payStatus;
    if (staff) {
      query.staff = staff;
    }
    if (orderNo) {
      query.orderNo = orderNo;
    }
    if (orderId) {
      query.orderId = orderId;
    }
    if (packageId) {
      query.packageId = packageId;
    }
    if (payChannel) {
      query.payChannel = payChannel;
    }
    if (payFlowNo) {
      query.payFlowNo = payFlowNo;
    }
    if (receiptFlowNo) {
      query.receiptFlowNo = receiptFlowNo;
    }
    this.$router.push({
      query,
    });
  }


  /** 赠送时长 */
  give(no: string) {
    // console.log('sssss');
    this.cacheNo = no;
    this.giveOrderVisible = true;
  }

  openSalesmanChange(order: any) {
    // console.log(order);
    this.currentOrder = order;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.carSalesmanChange.open();
  }

  closeSalesmanChange() {
    this.currentOrder = null;
  }
  async getList(query: any) {
    const res = await this.carService.auditEditShopOrder(query, this.$el);
    if (res) {
      this.listData = res.list;
      this.pagination.total = res.total;
      this.pagination.current = res.page;
    }
  }
  mounted() {
    this.handleSearch();
  }
  async lookReceiptVoucherImg(val: any, type: string) {
    if (type === 'pay') {
      const res = await this.carService.shopShopOrderPayVoucher({ orderNo: val.order_no });
      if (res) {
        this.voucherImgDrawer.open(res);
      }
    } else {
      const res = await this.carService.shopShopOrderReceiptVoucher({ orderNo: val.order_no });
      if (res) {
        this.voucherImgDrawer.open(res);
      }
    }
  }
}
